var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 custom-shadow rounded-2xl bg-white text-sm"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }